export default __webpack_public_path__ + "static/media/order.3436e147.svg";